export default __webpack_public_path__ + "static/media/faq.b712e021.svg";